import * as React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { I18n } from "../utils/I18n";
import { DeleteIcon } from "../utils/Icons";


export class YesNoCancelModalProps {
    YesText: string | null;
    onYes: () => void;

    NoText: string | null;
    onNo: () => void;
    onCancel: () => void;
    confirmTitle?: string;
    confirmBody?: string;
    mostrarCancelar?: boolean;
}


export function YesNoCancelModal(props: YesNoCancelModalProps): JSX.Element {

    var closeButton = <button className="btn-close" onClick={() => props.onCancel()}>&nbsp;</button>;

    return <Modal isOpen={true} className="wide-dialog">

        <ModalHeader close={closeButton}>
            {props.confirmTitle}
        </ModalHeader>

        <ModalBody>
            <p>{props.confirmBody}</p>
        </ModalBody>

        <ModalFooter>
            <Button color="primary"
                onClick={() => props.onYes()}>
                {props.YesText || "SI"}
            </Button>

            <Button color="secondary"
                onClick={() => props.onNo()}
            >
                {props.NoText || "NO"}
            </Button>

            {props.mostrarCancelar && <Button color="secondary"
                onClick={() => props.onCancel()}
            >
                {I18n.Strings.cancel}
            </Button>}

        </ModalFooter>
    </Modal>;
}
